export const dataProperties = 'dataProperties';
